import { render, staticRenderFns } from "./IntroductionComponent.vue?vue&type=template&id=0bdc4988&scoped=true&"
import script from "./IntroductionComponent.vue?vue&type=script&lang=js&"
export * from "./IntroductionComponent.vue?vue&type=script&lang=js&"
import style0 from "./IntroductionComponent.vue?vue&type=style&index=0&id=0bdc4988&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdc4988",
  null
  
)

export default component.exports